import React from "react";
import "../../css/AdditionalDetails.css";
import addPhoto from "../../images/addPhoto.png";
import advancedDetails from "../../images/advancedDetails.png";
import verify from "../../images/verify.png";
import returnHome from "../../images/return.png";
import { useNavigate } from "react-router-dom";
import { useState } from "react";
import finalProp from "../../images/FinalProp.png";
import procImg from "../../images/procedure.png";

export default function VerifyProperty() {
  const [showPopup, setShowPopup] = useState(false);
  const navigate = useNavigate();
  const handlePostPropertyClick = () => {
     setShowPopup(true);
  }
  return (
    <div className="exterior1">
    <div className="property-container1">
      <div className="property-left-box">
        <div className="property-header">
          <p className="property-title">Congratulations! Your Property Is Under Review.</p>
          <p className="property-subtitle">
            Meanwhile, You Can Add Photos & Other Additional <br /> Details To Receive More Enquiries.
          </p>
        </div>
        <div className="property-options-box">
        <div className="options-cat">
    <img src={returnHome} alt="Return to Dashboard" />
    <button className="options-cat-name" 
    onClick={() => navigate('/')}>
      Return To Dashboard</button>
  </div>
  <div className="options-cat">
    <img src={addPhoto} alt="Add Photos/Videos" />
    <button className="options-cat-name"
    onClick={() => navigate('/additionalDetails')}>
      Add Photos/Videos</button>
  </div>
  <div className="options-cat">
    <img src={advancedDetails} alt="Advanced Details" />
    <button className="options-cat-name"
    onClick={() => navigate('/advancedDetails')}>
      Advanced Details</button>
  </div>
  <div className="options-cat">
    <img src={verify} alt="Verify Your Property" />
    <button className="options-cat-name"
    onClick={() => navigate('/verifyProperty')}>
      Verify Your Property</button>
  </div>
</div>
      </div>
      <div className="property-right-box1">
    <div className="rightBox-title">
      <div>Verify Your Property</div>
      <div className="imgBox">
        <img src={procImg}/> 
        </div>
    </div>
    <div className="formBody2">
    We will visit the property to verify it. Schedule the date and we’ll get back to you first on call then on location. 
  Please be on location at the scheduled date and time.
    
    <div className="ribbon2">
              <input type="date" placeholder="Select Date" className="textField" />
              <input type="time" placeholder='Select Time' className='textField'/>
      <div className="instext"><button className="insbutton">Set Reminder</button></div>
    </div>
    <div className="finalribbon">
    <button className="finalskip" onClick={handlePostPropertyClick}>Skip &gt;&gt;</button>
    </div>
    </div>
      </div>
    </div>

    {showPopup && (
  <div className="popup1">
    <img src={finalProp} alt="Popup" className="popupImage1" />
    <button 
      className="popupCloseButton1" 
      onClick={() => {
        setShowPopup(false); 
        navigate('/'); 
      }}
    >
      &times; 
    </button>
  </div>
)}
    </div>  
  );
}
